export default function scrollIntoView(target, options = {}) {
  const targetStr = target.toLowerCase();
  options.behavior = options.behavior || 'smooth';
  options.block = options.block || 'start';
  const element = document.querySelector(`[scroll-identity=${targetStr}]`);
  element.scrollIntoView(options);
}
